import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const CapoclasseCrown = ({ placement = 'top', ...rest }) => (
  <OverlayTrigger
    placement={placement}
    overlay={
      <Tooltip
        style={{ position: 'fixed', zIndex: '2000' }}
        id="capoclasse-tooltip"
      >
        CapoClasse
      </Tooltip>
    }
  >
    <span {...rest}>
      <FontAwesomeIcon icon="crown" className="text-primary" />
    </span>
  </OverlayTrigger>
);

// proptypes validation
CapoclasseCrown.propTypes = {
  placement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  className: PropTypes.string
};

export default CapoclasseCrown;
